import styled from 'styled-components';
import { useFormikContext } from 'formik';
import { black } from '@avangard/ui/colors';

import { useStudentOnlineApplication } from '@modules/students/hooks';
import { getDocumentsGroupLabel } from '@modules/students/helpers';
import {
    StudentOnlineApplicationBlock,
    StudentOnlineApplicationDocument,
} from '@modules/students/moleculas';

import type { UpdateStudentOnlineApplicationFormValues } from '@modules/students/requests';

const StudentOnlineApplicationDocumentsStep = () => {
    const { values } = useFormikContext<UpdateStudentOnlineApplicationFormValues>();

    const { studentOnlineApplication } = useStudentOnlineApplication({
        returnPartialData: true,
    });

    return (
        <>
            <StudentOnlineApplicationBlock
                title='Загрузка документов'
                description={
                    <>
                        <p>{getDocumentsGroupLabel('title', values.isAdult)}</p>
                        <p>Загружайте файлы в pdf или jpg до 10 Мб.</p>
                    </>
                }
            >
                <Content>
                    {studentOnlineApplication.documents.map(document => (
                        <StudentOnlineApplicationDocument key={document.type} document={document} />
                    ))}
                </Content>
            </StudentOnlineApplicationBlock>
        </>
    );
};

const Content = styled.div`
    padding-top: 20px;

    & > * {
        padding-bottom: 20px;

        &:not(:last-child) {
            margin-bottom: 20px;
            border-bottom: 1px solid ${black[23]};
        }
    }
`;

export { StudentOnlineApplicationDocumentsStep };
